import s from './update-avatar-modal.module.scss'
import classNames from 'classnames'
import { Modal } from '@shared/ui/modal/modal';
import { useRef, useState } from 'react';
import Avatar from 'react-avatar-edit';
import { Button } from '@shared/ui/button/button';
import { IconPhoto } from '@tabler/icons-react';
import { useUpdateAvatarModal } from '../../model/use-update-avatar-modal';
import { useUpdateProfileAvatar } from '../../api/useUpdateProfileAvatar';
import { b64toBlob } from '@utils/lib/b64toBlob';

export const UpdateAvatarModal = () => {
	const { isOpen, close } = useUpdateAvatarModal()	

	const [img, setImg] = useState(null)
	const avatarRef = useRef()

	const { mutate: updateProfileAvatar } = useUpdateProfileAvatar()

	const onCrop = (view) => {
		setImg(view)
	}

	const onClose = () => {
		setImg(null)
	}

	const onSave = () => {
		if(img){
			const b64url = img
			const splitURL = b64url.split(",");
			const contentType = splitURL[0].split(":")[1].split(";")[0];
			const b64Data = splitURL[1];
			const blob = b64toBlob(b64Data, contentType);
			updateProfileAvatar(blob)
			close()
		}
	};

  return (
		<Modal {...{isOpen, close}} title='Фото профиля'>
			<div className={s.card}>
				<p className={s.subtitle}>Загрузите фото и отредактируйте область обрезки</p>
				<div className={classNames(s.editor, img && s.editorHasImage)}>
					<Avatar
						exportAsSquare
						label={
							<div className={s.uploadPrompt}>
								<IconPhoto size={32} />
								<span>Выберите файл</span>
							</div>
						}
						width={300}
						height={300}
						ref={avatarRef}
						onCrop={onCrop}
						onClose={onClose}
					/>
				</div>
				<Button onClick={() => onSave()} label='Сохранить' className={s.btn} disabled={!img}/>
			</div>
		</Modal>
  );
};
